// Vue 2 advanced async component for a panel that is the *entire* content of
// a modal sheet.
//
// A bare `() => import(...)` factory renders nothing until its chunk lands,
// so a sheet built around one (show-header="false", spinner inside the panel)
// is an empty white box while the chunk downloads — and stays empty for good
// if the request fails. That last case is not hypothetical here: route chunks
// are content-hashed and deleted on every deploy (see utils/versionWatch), and
// the forced full page load that covers it only runs on navigations — opening
// a global modal is not one. The stand-ins below give the sheet something to
// show in both cases.

// Long enough for a slow mobile connection, short enough that a request that
// will never complete does not hold the sheet empty indefinitely.
export const PANEL_CHUNK_TIMEOUT = 15000;

export default function asyncPanel(
  load,
  { loading, error, timeout = PANEL_CHUNK_TIMEOUT } = {}
) {
  return () => ({
    component: load(),
    loading,
    error,
    // No grace period: an empty sheet for "just a moment" is the bug.
    delay: 0,
    timeout
  });
}
